import React, { useState, useEffect, useRef } from "react";
import "./VolumeIndicator.css";

const VolumeIndicator = ({ volume, isVisible, isMobile = false }) => {
  const [opacity, setOpacity] = useState(0);
  const hideTimerRef = useRef(null);

  useEffect(() => {
    if (isVisible) {
      // نمایش با انیمیشن
      setOpacity(1);

      // پاک کردن تایمر قبلی
      if (hideTimerRef.current) {
        clearTimeout(hideTimerRef.current);
      }

      // مخفی کردن بعد از ۱.۵ ثانیه بی‌حرکتی
      hideTimerRef.current = setTimeout(() => {
        setOpacity(0);
      }, 1500);
    } else {
      setOpacity(0);
    }

    return () => {
      if (hideTimerRef.current) {
        clearTimeout(hideTimerRef.current);
      }
    };
  }, [isVisible, volume]); // با هر تغییر volume هم تایمر رو ریست می‌کنیم

  const getVolumeIcon = () => {
    if (volume === 0) return "🔇";
    if (volume < 0.3) return "🔈";
    if (volume < 0.7) return "🔉";
    return "🔊";
  };

  return (
    <div
      className={`volume-indicator ${isMobile ? "mobile" : "desktop"}`}
      style={{ opacity }}
    >
      <span className="volume-icon">{getVolumeIcon()}</span>
      <div className="volume-bar">
        <div className="volume-level" style={{ height: `${volume * 100}%` }} />
      </div>
      <span className="volume-text">{Math.round(volume * 100)}%</span>
    </div>
  );
};

export default VolumeIndicator;
